/**
 * Tells if a value is empty, null or undefined
 * @param value
 */
export const isNot = (value: undefined): boolean => {
  return value === '' || value === null || value === undefined;
};
